export default "__VITE_ASSET__3ucIf5r1__"